


















































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";
import CategoryTypeSelect from "../general/CategoryTypeSelect.vue";
import Loading from "../general/Loading.vue";

import SettingsJson from "../../shared/SettingsJson";
import ClientJson, { defaultClientJson } from "../../shared/ClientJson";
import { ClientStatus } from "../../shared/ClientStatus";
import { AccountStatus } from "../../shared/AccountStatus";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "ClientsClientSelect",
  components: {
    OverlayWindow,
    PointerMenu,
    OnscreenMenu,
    Loading,
    TableView,
    CategoryTypeSelect,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      CategoryTypeType: CategoryTypeType,
      supportsDatePicker: false,
      detailsTitle: "Person auswählen",
      UserPermissionRank: UserPermissionRank,
      showClientSelect: false as boolean,
      useFilters: false as boolean,
      filterCategoryTypes: [] as CategoryTypeJson[],
      filterRestrictedTypesManagement: false as boolean,
      searchString: null as string | null,
      allClients: null as ClientJson[] | null,
      clientsMoreAvailable: null as boolean | null,
      hasChanges: false,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initView();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    initView() {
      this.loadAllClients();
    },

    setCachedData() {
      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadAllClients(loadMore: null = null) {
      //show loading on search or remove search
      if (this.searchString !== null) {
        if (loadMore == null) {
          this.allClients = null;
        }
        if (this.searchString == "") {
          this.searchString = null;
        }
      }

      var typeIds = null;
      var onlyCreatedByManagement = false;
      var skipAmount = null as number | null;

      //filters
      if (this.useFilters) {
        if (this.filterCategoryTypes.length > 0) typeIds = this.filterCategoryTypes.map((i: CategoryTypeJson) => i.ID!);
        onlyCreatedByManagement = this.filterRestrictedTypesManagement;
      }

      //load more
      if (loadMore && this.allClients != null) {
        this.clientsMoreAvailable = null;
        skipAmount = this.allClients.length;
      } else {
        this.allClients = null;
      }

      if (this.restClient != null) {
        try {
          let clients = await this.restClient.getClients(
            typeIds,
            onlyCreatedByManagement,
            false,
            false,
            this.searchString,
            skipAmount
          );

          if (loadMore && this.allClients != null) {
            this.allClients = this.allClients.concat(clients.clients);
          } else {
            this.allClients = clients.clients;
          }

          this.clientsMoreAvailable = clients.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //START set cached data

    //END set cached data

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();

      this.loadAllClients();
    },

    removeUseFilters() {
      this.useFilters = false;

      this.filterCategoryTypes = [];
      this.filterRestrictedTypesManagement = false;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();

      this.loadAllClients();
    },

    selectClient(item: ClientJson) {
      this.$emit("change", item);
      this.closeDetails();
    },

    resetSearchString() {
      this.searchString = "";

      this.loadAllClients();
    },

    closeDetails() {
      //this.$emit("closeOverlay");
      this.showClientSelect = false;
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "selectClient") {
        this.selectClient(item);
      }
    },

    tableViewItemClicked(item: any) {
      this.selectClient(item);
    },
  },

  watch: {},

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    clientColumns: function (): TableViewColumnDefinitions<ClientJson>[] {
      let vue = this;

      return [
        {
          th: "Vorname",
          td: (i) => (i.contact?.firstName != "" ? i.contact?.firstName : "--"),
        },
        {
          th: "Nachname",
          td: (i) => (i.contact?.lastName != "" ? i.contact?.lastName : "--"),
        },
        {
          th: "E-Mail",
          td: (i) => (i.contact?.email != "" ? i.contact?.email : "--"),
        },
        {
          th: "Art",
          td: (i) => i.rentalTypes.join(", "),
        },
        {
          th: "Account",
          td: (i) => (i.username ? "Ja" : "Nein"),
        },
        {
          th: "",
          td: (i) => "Auswählen",
          style: (i) => "text-align:right",
          button: "selectClient",
        },
      ] as TableViewColumnDefinitions<ClientJson>[];
    },

    filteredClients(): ClientJson[] | undefined {
      if (this.allClients != null) {
        return this.allClients.filter(function (i: ClientJson) {
          if (i.state == ClientStatus.active) {
            if (i.username && i.accountState == AccountStatus.active) {
              return true;
            }

            return true;
          }

          return false;
        });
      }
    },
  },
});
